import React, { useState, useEffect, useRef } from 'react';
import { playClick, playTick, playVictory } from '../sounds';

const GAME_MODES = [
  {
    key: 'spyq',
    name: 'SpyQ',
    icon: '🕵️',
    desc: 'מרגל, טריוויה, וחשיפות - מי המרגל ביניכם? (3-6)',
    color: '#8B5CF6',
  },
  {
    key: 'thatsyou',
    name: 'בלי פילטר!',
    icon: '🎭',
    desc: 'שאלות, דילמות, ציורים, השלמות מצחיקות ודעות חמות! (3-6)',
    color: '#34D399',
  },
  {
    key: 'mystery',
    name: 'חדר חקירות',
    icon: '🔍',
    desc: 'פתרו תעלומות יחד - כל שחקן מקבל רמזים שונים! (2-8)',
    color: '#DC3545',
  },
  {
    key: 'wordguess',
    name: 'תן רמז!',
    icon: '💡',
    desc: 'ציירו או כתבו רמזים - השאר מנחשים את המילה! (2-6)',
    color: '#00B4D8',
  },
  {
    key: 'complete',
    name: 'מה ההמשך?',
    icon: '💬',
    desc: 'השלימו משפטים מצחיקים והצביעו על הכי טוב! (3-8)',
    color: '#E040FB',
  },
  {
    key: 'trivia',
    name: 'מי יודע?',
    icon: '🧠',
    desc: 'שאלות טריוויה מהירות - מי עונה נכון הכי מהר? (2-8)',
    color: '#00E676',
  },
  {
    key: 'countrycity',
    name: 'ארץ עיר!',
    icon: '🌍',
    desc: 'בחרו אות, מלאו קטגוריות - מי ממלא הכל ראשון? (2-8)',
    color: '#F59E0B',
  },
  {
    key: 'fakeartist',
    name: 'האמן המזויף',
    icon: '🎭',
    desc: 'כולם מציירים אותה מילה - חוץ מאחד שלא יודע! גלו אותו (3-6)',
    color: '#FBBF24',
  },
];

const AVATARS = ['😎', '🤩', '🥳', '😈', '🤠', '👻', '🦊', '🐸', '🦄', '🐱', '🐶', '🦁', '🐧', '🎃', '🤖', '👽'];

const SPYQ_RULES = [
  'אחד מכם הוא מרגל - הוא לא רואה את השאלה!',
  'כולם בוחרים תשובה (המרגל מנחש)',
  'רואים מי ענה מה ודנים - מי נראה חשוד?',
  'מצביעים - מי המרגל?',
];

const THATSYOU_RULES = [
  'עונים על שאלות כיפיות על החברים',
  '"מי הכי..." - בחרו מישהו מהקבוצה',
  '"מה מעדיפים?" - A או B, רואים מי חושב כמוכם',
  '"דעה חמה" - מסכימים או לא?',
];

const MYSTERY_RULES = [
  'כל שחקן מקבל רמזים שונים - קראו אותם בשקט!',
  'שתפו את הרמזים שלכם בעל פה עם שאר השחקנים',
  'דונו ביניכם - מי לדעתכם האשם?',
  'כל שחקן מצביע בסוד - ורואים אם צדקתם!',
];

const STORY_RULES = [
  'כל שחקן מוסיף משפט לסיפור - בתור',
  'אתם רואים רק את המשפט הקודם!',
  'בסוף - קוראים את הסיפור המלא (בד"כ מצחיק מאוד)',
  'מצביעים על המשפט הכי מצחיק',
];

const WORDGUESS_RULES = [
  'בכל סיבוב שחקן אחד רואה מילה סודית',
  'הוא בוחר: לצייר או לכתוב רמזים',
  'השאר מנסים לנחש מה המילה!',
  'כל שחקן נותן רמזים פעמיים',
];

const COMPLETE_RULES = [
  'רואים תחילת משפט ומשלימים אותו',
  'כל ההשלמות מוצגות בעילום שם',
  'מצביעים על ההשלמה הכי מצחיקה',
  'אחרי ההצבעה - מגלים מי כתב מה!',
];

const TRIVIA_RULES = [
  'שאלת טריוויה עם 4 תשובות אפשריות',
  'ענו נכון וכמה שיותר מהר - מקבלים בונוס מהירות!',
  '12 שאלות ממגוון קטגוריות',
  'מי שצבר הכי הרבה נקודות מנצח!',
];

const COUNTRYCITY_RULES = [
  'שחקן בוחר אות - האותיות מתחלפות על המסך!',
  'כולם ממלאים 8 קטגוריות: ארץ, עיר, חי, צומח, דומם, אישיות, שם ילד, שם ילדה',
  'הראשון שסיים לוחץ "סיימתי!" - השאר מקבלים 15 שניות',
  'מצביעים על כל תשובה - תשובה ייחודית = 10, כפולה = 5',
];

const FAKEARTIST_RULES = [
  'כולם מקבלים את אותה מילה לצייר - חוץ מאחד! המזויף לא יודע מה המילה',
  'בתורות - כל אחד מצייר על קנבס משותף, פרט אחד מהמילה',
  'המזויף צריך לאלתר ולהשתלב מבלי שיתפסו אותו',
  'בסוף כל סיבוב מצביעים מי המזויף - אם נחשף יקבל הזדמנות לנחש את המילה',
];

const HOST_GUIDE = {
  spyq: [
    'בחרו רמת קושי - קל לחדשים, קשה למנוסים',
    'המשחק רץ לבד - השלבים מתחלפים אוטומטית',
    'בסוף כל סיבוב לחצו "סיבוב הבא" להמשיך',
    'אחרי הסיבוב האחרון תוכלו להתחיל משחק חדש',
  ],
  thatsyou: [
    'מצב "מהיר" = פחות סיבובים וזמן קצר יותר',
    'יש 6 סוגי סיבובים: שאלות, דילמות, דעות, ציור, השלמות, ומי זה',
    'המשחק רץ לבד - הכל אוטומטי',
    'בסוף מוענקים פרסים מיוחדים לשחקנים',
  ],
  mystery: [
    'אתם שולטים בקצב! לחצו "הבא" כשכולם מוכנים לשלב הבא',
    'שלב הראיות - תנו לכולם זמן לקרוא את הרמזים שלהם',
    'שלב הדיון - עודדו את כולם לשתף מה שיש להם',
    'אחרי ההצבעה - החשיפה היא אוטומטית',
    'אפשר לשחק כמה תעלומות ברצף!',
  ],
  story: [
    'המשחק רץ לבד - כל שחקן מקבל תור אוטומטי',
    'יש 30 שניות לכתוב כל משפט',
    'בסוף - קריאה משותפת של הסיפור והצבעה',
    'לחצו "סיבוב הבא" לסיפור חדש',
  ],
  wordguess: [
    'בחרו רמת קושי - קובעת את המילים',
    'כל שחקן נותן רמזים פעמיים',
    'הנותן בוחר אם לצייר או לכתוב רמזים',
    'המשחק רץ אוטומטית - רק "סיבוב הבא" בסוף',
  ],
  complete: [
    'המשחק רץ לבד - 8 סיבובים',
    'ההשלמות אנונימיות עד ההצבעה',
    'עודדו את כולם להיות יצירתיים ומצחיקים!',
  ],
  trivia: [
    'המשחק רץ לבד - 12 שאלות',
    'מהירות חשובה - בונוס על תשובה מהירה',
    'לחצו "סיבוב הבא" בסוף לסט חדש',
  ],
  countrycity: [
    'שחקן בוחר אות - ואז כולם ממלאים 8 קטגוריות',
    'מי שסיים ראשון - לוחץ סיימתי והשאר מקבלים 15 שניות',
    'אחרי המילוי - מצביעים אם התשובות חוקיות',
    'תשובה ייחודית = 10 נקודות, כפולה = 5',
  ],
  fakeartist: [
    'בחרו רמת קושי - קובעת כמה המילה קשה',
    'מספר הסיבובים = מספר השחקנים. כל סיבוב יש מזויף אחר',
    'בכל סיבוב כל אחד מצייר 2 פעמים על קנבס משותף - אל תחשפו את המילה!',
    'בסוף סיבוב מצביעים על המזויף; אם נחשף הוא מנחש את המילה לבונוס',
  ],
};

function Lobby({ roomData, roomCode, playerId, sendMessage, error, clearError }) {
  const [copied, setCopied] = useState(false);
  const [showAvatars, setShowAvatars] = useState(false);
  const [editingName, setEditingName] = useState(false);
  const [newName, setNewName] = useState('');

  // Slot-machine random mode picker
  const [randomizing, setRandomizing] = useState(false);
  const [highlightedKey, setHighlightedKey] = useState(null);
  const [secondsLeft, setSecondsLeft] = useState(0);
  const randomTimers = useRef([]);

  useEffect(() => () => {
    randomTimers.current.forEach((t) => clearTimeout(t));
    randomTimers.current = [];
  }, []);
  const isHost = roomData.hostId === playerId;
  const gameMode = roomData.gameMode || 'spyq';
  const quickMode = roomData.quickMode || false;
  const chatEnabled = roomData.chatEnabled || false;
  const myPlayer = roomData.players.find((p) => p.id === playerId);
  const amReady = myPlayer?.ready || false;
  const minPlayers = (gameMode === 'mystery' || gameMode === 'story' || gameMode === 'wordguess' || gameMode === 'trivia' || gameMode === 'countrycity') ? 2 : (gameMode === 'fakeartist' ? 3 : 3);
  const allReady = roomData.players.length >= minPlayers && roomData.players.every((p) => p.ready);
  const rulesMap = { spyq: SPYQ_RULES, thatsyou: THATSYOU_RULES, mystery: MYSTERY_RULES, story: STORY_RULES, wordguess: WORDGUESS_RULES, complete: COMPLETE_RULES, trivia: TRIVIA_RULES, countrycity: COUNTRYCITY_RULES, fakeartist: FAKEARTIST_RULES };
  const rules = rulesMap[gameMode] || SPYQ_RULES;

  const gameLink = `${window.location.origin}/game/${roomCode}`;

  const copyLink = () => {
    navigator.clipboard.writeText(gameLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      navigator.clipboard.writeText(roomCode).catch(() => {});
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const shareWhatsApp = () => {
    const text = `🎮 הצטרפו אליי למשחק ב-SpyQ!\nקוד חדר: ${roomCode}\n\n${gameLink}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  const handleStart = () => {
    clearError();
    sendMessage('START_GAME', {});
  };

  const handleReady = () => {
    sendMessage('PLAYER_READY', {});
  };

  const setDifficulty = (diff) => {
    clearError();
    sendMessage('SET_DIFFICULTY', { difficulty: diff });
  };

  const setMode = (mode) => {
    clearError();
    sendMessage('SET_MODE', { mode });
  };

  // Slot-machine: cycle through modes for ~5s, slow → fast, then land on a random mode.
  const startRandomMode = () => {
    if (randomizing) return;
    clearError();
    playClick();
    setRandomizing(true);

    const totalDuration = 5000;
    const startDelay = 450; // slow at start
    const endDelay = 55;   // very fast at end
    const startTime = Date.now();

    // Pick the final landing index up-front so we can guarantee we stop on it.
    // We pick BEFORE cycling so the visual lines up; the cycle will
    // naturally land somewhere, then we override the last one to the target.
    const targetIndex = Math.floor(Math.random() * GAME_MODES.length);

    let i = Math.floor(Math.random() * GAME_MODES.length);
    setHighlightedKey(GAME_MODES[i].key);

    // Countdown 5..1 in seconds
    setSecondsLeft(5);
    for (let s = 4; s >= 0; s--) {
      const t = setTimeout(() => setSecondsLeft(s), (5 - s) * 1000);
      randomTimers.current.push(t);
    }

    const tick = () => {
      const elapsed = Date.now() - startTime;
      const t = Math.min(1, elapsed / totalDuration);
      // Quadratic ease-in: slow at start, fast at end
      const eased = t * t;
      const delay = Math.round(startDelay - (startDelay - endDelay) * eased);

      i = (i + 1) % GAME_MODES.length;
      setHighlightedKey(GAME_MODES[i].key);
      try { playTick(); } catch {}

      if (elapsed >= totalDuration) {
        // Land on the pre-picked target
        setHighlightedKey(GAME_MODES[targetIndex].key);
        try { playVictory(); } catch {}
        sendMessage('SET_MODE', { mode: GAME_MODES[targetIndex].key });
        const t1 = setTimeout(() => {
          setRandomizing(false);
          setHighlightedKey(null);
          setSecondsLeft(0);
        }, 900);
        randomTimers.current.push(t1);
        return;
      }
      const next = setTimeout(tick, delay);
      randomTimers.current.push(next);
    };
    const first = setTimeout(tick, startDelay);
    randomTimers.current.push(first);
  };

  return (
    <>
      <div className="logo-small">SpyQ</div>
      <div className="card">
        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <p style={{ color: 'var(--ink-3)', fontSize: '0.85rem', marginBottom: '4px', fontWeight: 600 }}>קוד החדר</p>
          <div className="room-code-display">{roomCode}</div>
          <button className="btn btn-ghost" onClick={shareWhatsApp} style={{ maxWidth: '240px', margin: '0 auto 4px', background: 'rgba(37,211,102,0.15)', border: '1px solid rgba(37,211,102,0.3)' }}>
            📱 שלח בוואטסאפ
          </button>
          <button className="btn btn-ghost" onClick={copyLink} style={{ maxWidth: '240px', margin: '0 auto 4px', fontSize: '0.8rem', padding: '6px' }}>
            {copied ? '✓ הועתק!' : '📋 העתק קישור'}
          </button>
        </div>

        <h3 style={{ marginBottom: '8px', fontSize: '0.85rem', color: 'var(--ink-2)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          שחקנים ({roomData.players.length}/{gameMode === 'mystery' ? 8 : 6})
        </h3>
        <ul className="player-list">
          {roomData.players.map((player) => (
            <li key={player.id} className={`player-item ${!player.connected ? 'disconnected' : ''}`}>
              <span className="player-name" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '1.3rem' }}>{player.avatar || '👤'}</span>
                {player.id === playerId && editingName ? (
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    if (newName.trim()) {
                      sendMessage('SET_NAME', { name: newName.trim() });
                      setEditingName(false);
                    }
                  }} style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                    <input
                      autoFocus
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                      onBlur={() => {
                        if (newName.trim()) sendMessage('SET_NAME', { name: newName.trim() });
                        setEditingName(false);
                      }}
                      maxLength={20}
                      className="input"
                      style={{ padding: '4px 8px', fontSize: '0.9rem', width: '120px', height: '30px' }}
                    />
                  </form>
                ) : (
                  <>
                    {player.name}
                    {player.isHost && <span className="host-badge">מנהל</span>}
                    {player.id === playerId && <span className="me-badge">(אני)</span>}
                  </>
                )}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {player.id === playerId && !editingName && (
                  <>
                    <button
                      onClick={() => { setNewName(player.name); setEditingName(true); }}
                      style={{ background: 'none', border: 'none', color: 'var(--ink-2)', fontSize: '0.75rem', cursor: 'pointer', padding: '2px 6px', fontWeight: 600 }}
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => setShowAvatars(!showAvatars)}
                      style={{ background: 'none', border: 'none', color: 'var(--ink-2)', fontSize: '0.75rem', cursor: 'pointer', padding: '2px 6px', fontWeight: 600 }}
                    >
                      {showAvatars ? '✕' : 'אווטאר'}
                    </button>
                  </>
                )}
                <span style={{
                  fontSize: '0.78rem', fontWeight: 700,
                  padding: '4px 10px', borderRadius: '999px',
                  background: player.ready ? 'rgba(123,155,94,0.15)' : 'var(--surface-sunk)',
                  color: player.ready ? 'var(--success)' : 'var(--ink-3)',
                  border: player.ready ? '1px solid rgba(123,155,94,0.35)' : '1px solid var(--ink-4)',
                }}>
                  {player.ready ? '✓ מוכן' : 'ממתין'}
                </span>
              </div>
            </li>
          ))}
          {roomData.players.length < minPlayers && (
            <li className="player-item" style={{
              opacity: 0.6,
              border: '1px dashed var(--ink-4)',
              background: 'var(--surface-sunk)',
            }}>
              <span className="player-name" style={{ color: 'var(--ink-3)' }}>ממתינים לשחקנים...</span>
            </li>
          )}
        </ul>

        {showAvatars && (
          <div style={{
            display: 'flex', flexWrap: 'wrap', gap: '6px', justifyContent: 'center',
            padding: '12px', marginBottom: '12px', borderRadius: '14px',
            background: 'var(--surface-sunk)', border: '1px solid var(--ink-4)',
          }}>
            {AVATARS.map((av) => {
              const selected = myPlayer?.avatar === av;
              return (
                <button
                  key={av}
                  onClick={() => { sendMessage('SET_AVATAR', { avatar: av }); setShowAvatars(false); }}
                  aria-label={`בחר אווטאר ${av}`}
                  aria-pressed={selected}
                  style={{
                    fontSize: '1.4rem', width: '40px', height: '40px', borderRadius: '50%', cursor: 'pointer',
                    background: selected ? 'var(--terracotta-wash)' : 'var(--surface-raised)',
                    border: selected ? '2.5px solid var(--terracotta)' : '1.5px solid var(--ink-4)',
                    boxShadow: selected ? 'var(--shadow-glow-coral)' : 'var(--shadow-1)',
                    transition: 'all 0.15s',
                    padding: 0,
                  }}
                >{av}</button>
              );
            })}
          </div>
        )}

        {isHost && (
          <>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              marginBottom: '10px', marginTop: '16px',
            }}>
              <h3 style={{ fontSize: '0.85rem', color: 'var(--ink-2)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', margin: 0 }}>
                בחרו משחק
              </h3>
              <button
                onClick={startRandomMode}
                disabled={randomizing}
                aria-label="הגרל משחק אקראי"
                style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  padding: '8px 14px', borderRadius: '999px',
                  background: randomizing ? 'var(--surface-sunk)' : 'var(--terracotta-wash)',
                  border: '1.5px solid var(--terracotta-soft)',
                  color: 'var(--terracotta-deep)',
                  fontFamily: 'Heebo, sans-serif', fontWeight: 800, fontSize: '0.85rem',
                  cursor: randomizing ? 'wait' : 'pointer',
                  boxShadow: randomizing ? 'none' : 'var(--shadow-1)',
                  transition: 'all 0.15s',
                }}
              >
                <span aria-hidden="true">🎲</span>
                {randomizing ? 'מגריל...' : 'הגרל משחק'}
              </button>
            </div>

            <div role="radiogroup" aria-label="בחירת משחק" aria-busy={randomizing} style={{
              display: 'grid', gap: '10px', marginBottom: '14px',
              position: 'relative',
            }}>
              {GAME_MODES.map((mode) => {
                const selected = gameMode === mode.key;
                const highlighted = randomizing && highlightedKey === mode.key;
                const dimmed = randomizing && !highlighted;
                return (
                  <button
                    key={mode.key}
                    onClick={() => !randomizing && setMode(mode.key)}
                    role="radio"
                    aria-checked={selected}
                    aria-label={`${mode.name} – ${mode.desc}`}
                    disabled={randomizing}
                    style={{
                      position: 'relative',
                      padding: '14px 16px', borderRadius: '14px',
                      border: highlighted
                        ? '2.5px solid var(--terracotta-deep)'
                        : selected ? '2.5px solid var(--terracotta)' : '1.5px solid var(--ink-4)',
                      background: highlighted
                        ? 'var(--terracotta-wash)'
                        : selected ? 'var(--terracotta-wash)' : 'var(--surface-raised)',
                      color: 'var(--ink)',
                      cursor: randomizing ? 'wait' : 'pointer',
                      fontFamily: 'Heebo, sans-serif',
                      textAlign: 'right', transition: 'all 0.12s var(--ease-spring)',
                      display: 'flex', alignItems: 'center', gap: '12px',
                      boxShadow: highlighted
                        ? '0 0 0 4px rgba(217,124,96,0.25), var(--shadow-glow-coral)'
                        : selected ? 'var(--shadow-glow-coral)' : 'var(--shadow-1)',
                      transform: highlighted ? 'translateY(-2px) scale(1.02)' : selected ? 'translateY(-1px)' : 'none',
                      opacity: dimmed ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: '1.8rem' }} aria-hidden="true">{mode.icon}</span>
                    <div style={{ flex: 1 }}>
                      <p style={{ fontWeight: 800, fontSize: '1.05rem', marginBottom: '2px', color: (selected || highlighted) ? 'var(--terracotta-deep)' : 'var(--ink)' }}>{mode.name}</p>
                      <p style={{ fontSize: '0.82rem', color: 'var(--ink-2)', lineHeight: 1.45 }}>{mode.desc}</p>
                    </div>
                    {selected && !randomizing && (
                      <span aria-hidden="true" style={{
                        flexShrink: 0,
                        width: '28px', height: '28px', borderRadius: '50%',
                        background: 'var(--terracotta)', color: 'white',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontWeight: 900, fontSize: '0.95rem',
                        boxShadow: 'var(--shadow-glow-coral)',
                      }}>✓</span>
                    )}
                  </button>
                );
              })}
            </div>

            {(gameMode === 'spyq' || gameMode === 'mystery' || gameMode === 'wordguess' || gameMode === 'fakeartist') && (
              <>
                <h3 style={{ marginBottom: '8px', fontSize: '0.85rem', color: 'var(--ink-2)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}>רמת קושי</h3>
                <div className="difficulty-selector" role="radiogroup" aria-label="רמת קושי">
                  {[
                    { key: 'easy', label: 'קלה' },
                    { key: 'medium', label: 'בינונית' },
                    { key: 'hard', label: 'קשה' },
                  ].map((d) => (
                    <button
                      key={d.key}
                      role="radio"
                      aria-checked={roomData.difficulty === d.key}
                      className={`difficulty-btn ${roomData.difficulty === d.key ? 'active' : ''}`}
                      onClick={() => setDifficulty(d.key)}
                    >
                      {d.label}
                    </button>
                  ))}
                </div>
              </>
            )}

            {gameMode === 'thatsyou' && (
              <div className="difficulty-selector" role="radiogroup" aria-label="קצב המשחק">
                <button
                  role="radio"
                  aria-checked={!quickMode}
                  className={`difficulty-btn ${!quickMode ? 'active' : ''}`}
                  onClick={() => sendMessage('SET_QUICK_MODE', { quickMode: false })}
                  style={{ flex: 1 }}
                >
                  🎯 רגיל
                </button>
                <button
                  role="radio"
                  aria-checked={quickMode}
                  className={`difficulty-btn ${quickMode ? 'active' : ''}`}
                  onClick={() => sendMessage('SET_QUICK_MODE', { quickMode: true })}
                  style={{ flex: 1 }}
                >
                  ⚡ מהיר
                </button>
              </div>
            )}
          </>
        )}

        {isHost && (
          <>
            <h3 style={{ marginBottom: '8px', marginTop: '16px', fontSize: '0.85rem', color: 'var(--ink-2)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              צ'אט במשחק
            </h3>
            <div className="difficulty-selector" role="radiogroup" aria-label="צ'אט במשחק">
              <button
                role="radio"
                aria-checked={!chatEnabled}
                className={`difficulty-btn ${!chatEnabled ? 'active' : ''}`}
                onClick={() => sendMessage('SET_CHAT', { enabled: false })}
                style={{ flex: 1 }}
              >
                🔇 ללא צ'אט
              </button>
              <button
                role="radio"
                aria-checked={chatEnabled}
                className={`difficulty-btn ${chatEnabled ? 'active' : ''}`}
                onClick={() => sendMessage('SET_CHAT', { enabled: true })}
                style={{ flex: 1 }}
              >
                💬 עם צ'אט
              </button>
            </div>
          </>
        )}

        <div style={{
          background: 'var(--surface-sunk)', borderRadius: '14px',
          padding: '16px', marginTop: '16px', marginBottom: '14px',
          border: '1px solid var(--ink-4)',
        }}>
          <h3 style={{ color: 'var(--terracotta-deep)', fontSize: '0.95rem', marginBottom: '10px', fontWeight: 800 }}>
            {({ thatsyou: '🎭', mystery: '🔍', story: '📖', wordguess: '💡', fakeartist: '🎨' }[gameMode] || '🕵️')} איך משחקים
          </h3>
          {rules.map((rule, i) => (
            <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '8px' }}>
              <span style={{
                background: 'var(--terracotta-wash)', color: 'var(--terracotta-deep)',
                borderRadius: '50%',
                minWidth: '22px', height: '22px', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontSize: '0.72rem', fontWeight: 900,
                border: '1px solid var(--terracotta-soft)',
                flexShrink: 0,
              }}>{i + 1}</span>
              <span style={{ color: 'var(--ink-1)', fontSize: '0.88rem', lineHeight: 1.55 }}>{rule}</span>
            </div>
          ))}
        </div>

        {isHost && (
          <div style={{
            background: 'var(--terracotta-wash)', borderRadius: '14px',
            padding: '16px', marginBottom: '14px',
            border: '1px solid var(--terracotta-soft)',
          }}>
            <h3 style={{ color: 'var(--terracotta-deep)', fontSize: '0.95rem', marginBottom: '10px', fontWeight: 800 }}>
              👑 מדריך למנהל
            </h3>
            {(HOST_GUIDE[gameMode] || HOST_GUIDE.spyq).map((tip, i) => (
              <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '8px' }}>
                <span style={{ color: 'var(--terracotta-deep)', fontSize: '0.95rem', marginTop: '0', lineHeight: 1, fontWeight: 900 }}>•</span>
                <span style={{ color: 'var(--ink-1)', fontSize: '0.88rem', lineHeight: 1.55 }}>{tip}</span>
              </div>
            ))}
          </div>
        )}

        {!amReady ? (
          <button className="btn btn-secondary" onClick={handleReady}>
            קראתי את ההוראות - מוכן!
          </button>
        ) : (
          <div style={{
            textAlign: 'center', padding: '12px',
            background: 'rgba(123,155,94,0.12)', borderRadius: '12px',
            border: '1px solid rgba(123,155,94,0.35)', marginBottom: '10px',
          }}>
            <p style={{ color: 'var(--success)', fontWeight: 800 }}>✓ מוכן!</p>
          </div>
        )}

        {!isHost && (
          <div style={{
            padding: '10px 12px', borderRadius: '12px', textAlign: 'center',
            background: 'var(--surface-sunk)', border: '1px solid var(--ink-4)',
            marginBottom: '10px',
          }}>
            <p style={{ fontSize: '0.85rem', color: 'var(--ink-2)' }}>
              משחק: <strong style={{ color: 'var(--ink)' }}>
                {GAME_MODES.find((m) => m.key === gameMode)?.icon} {GAME_MODES.find((m) => m.key === gameMode)?.name}
              </strong>
            </p>
          </div>
        )}

        {error && <p className="error-msg">{error}</p>}

        {isHost && (
          <button
            className="btn btn-primary"
            onClick={handleStart}
            disabled={!allReady}
            style={{ marginTop: '4px' }}
          >
            {roomData.players.length < minPlayers
              ? `ממתינים לעוד ${minPlayers - roomData.players.length} שחקנים`
              : !allReady
                ? `ממתינים שכולם יהיו מוכנים (${roomData.players.filter(p => p.ready).length}/${roomData.players.length})`
                : 'כולם מוכנים - התחל!'}
          </button>
        )}
      </div>

      {copied && <div className="copy-toast">הקישור הועתק!</div>}

      {randomizing && (
        <div
          aria-live="polite"
          aria-label="הגרלת משחק"
          style={{
            position: 'fixed', inset: 0, zIndex: 950,
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
            paddingTop: 'clamp(40px, 12vh, 120px)',
            background: 'rgba(43,38,34,0.18)',
            backdropFilter: 'blur(2px)',
            pointerEvents: 'none',
            animation: 'fadeIn 0.2s ease',
          }}
        >
          <div style={{
            background: 'var(--surface-raised)',
            border: '2px solid var(--terracotta)',
            borderRadius: '24px',
            padding: '18px 28px',
            boxShadow: 'var(--shadow-glow-coral), var(--shadow-4)',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px',
            minWidth: '160px',
          }}>
            <span style={{
              fontSize: '0.78rem', color: 'var(--ink-2)', fontWeight: 700,
              textTransform: 'uppercase', letterSpacing: '0.12em',
            }}>
              🎲 מגריל משחק
            </span>
            <span
              key={secondsLeft}
              style={{
                fontSize: '3.4rem', fontWeight: 900,
                color: 'var(--terracotta-deep)',
                lineHeight: 1,
                animation: 'cardEnter 0.35s var(--ease-spring)',
              }}
            >
              {secondsLeft}
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default Lobby;
